export const DrawingDiscPDList = ["설비", "건축", "전기", "제어", "소방"];
export const DPsubPDList = [
  "배관",
  "건축",
  "랙",
  "전기",
  "제어",
  "설비제어",
  "전기제어",
  "HVAC",
  "소방 기계",
  "소방 전기",
];
export const DPsubPD2List = ["모듈", "비모듈", "-", "GAL'V", "GAL'V 외"];
